import { useLacTenantsQuery } from '../queries/useLacTenantsQuery';
import { LAC_CHATBOTS_TAB_TOP_LIMIT } from '../lacChatbotsListParams';
import { useLacChatbotsSearchParams } from './useLacChatbotsSearchParams';

export function useLacChatbotsTab() {
  const tenantsQuery = useLacTenantsQuery();
  const filters = useLacChatbotsSearchParams({
    tenants: tenantsQuery.data,
  });

  return {
    tenantsQuery,
    filters,
    topLimit: LAC_CHATBOTS_TAB_TOP_LIMIT,
  };
}
